import React, { useMemo } from "react";
import { ISubCase, ICase } from "us.collection.transactions/interfaces";
import { getAdditionalReferenceStatusColor } from "us.common/functions";
/**
 * @description - The component used to render additional refference in the case and subcase view
 * @return {JSX.Element}
 * @author Keshan Nimnaka <keshana@unicorn-solutions.com>
 * @since 22/05/2025
 */
type AdditionalReferenceRendererProps = {
    renderingRecord: ICase | ISubCase;
    additionalReferenceItem: keyof (ICase | ISubCase);
};
const AdditionalReferenceRenderer: React.FC<AdditionalReferenceRendererProps> =
    ({ renderingRecord, additionalReferenceItem }) => {
        const additionalReferenceValue = renderingRecord[additionalReferenceItem];
        const referenceColor = useMemo(() => {
            return getAdditionalReferenceStatusColor(
                renderingRecord.additionalReference3
            );
        }, [renderingRecord.additionalReference3]);

        return (
            <>
                {additionalReferenceValue && (
                    <span
                        className="d-inline-block "
                        style={{ color: referenceColor }}
                    >
                        {additionalReferenceValue}
                    </span>
                )}
            </>
        );
    };

export default AdditionalReferenceRenderer;
